









































































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

@Component({
	components: {
		secondaryNav,
	},
	validations: {
		form: {
			email: { required, email },
			password: { required },
		},
	},
	mixins: [validationMixin],
})
export default class Login extends Vue {
	public form = {
		email: '',
		password: '',
		showPassword: false,
	};
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public error = null;

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		this.$auth
			.login({
				data: { email: this.form.email, password: this.form.password },
				fetchUser: true,
				rememberMe: true, // Configure token to be remembered after browser close.
			})
			.catch((error: any) => {
				this.submitStatus = 'ERROR';
				this.error = error;
			})
			.then((res: any) => {
				const token = res.data.token;
				localStorage.setItem('user-token', token);

				if (this.$route.query.from) {
					this.$router.replace(this.$route.query.from);
				} else {
					this.$router.push({ name: 'home' }).catch(err => {
						console.log("Error routing to 'home'", err);
						this.submitStatus = 'ERROR';
					});
				}
			});
	}
}
